import { render, staticRenderFns } from "./counterpartiesAdd.vue?vue&type=template&id=0aa58ed8"
import script from "./counterpartiesAdd.vue?vue&type=script&lang=js"
export * from "./counterpartiesAdd.vue?vue&type=script&lang=js"
import style0 from "./counterpartiesAdd.vue?vue&type=style&index=0&id=0aa58ed8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports